'use strict'

import Element from './element.js'
import { KeyCode } from '../adapter.js'
import _ from 'lodash'
import { getOrientation, LANDSCAPE, PORTRAIT } from '@/pages/conference/js/chat.utils'

const MESSAGE_PREFIX = ' : '
const LAST_MESSAGE_YESTERDAY = '어제'
const MORE_MESSAGE_BELOW = '메시지 더보기'

class MessageBoard extends Element {
  constructor (parent) {
    super()
    this.setClass('message-board')
    this.$chat = parent
    this.$chatBoard = parent.$chatBoard

    let $content = new Element()
    $content.setClass('content')
    this.appendElement($content)

    let $contentInput = this.$contentInput = new Element()
    $contentInput.setClass('content-input')

    let $input = new Element('input')
    $input.setClass('input')
    $input.attr('autocomplete', 'off')
    $input.attr('id', 'sb-chat-input')
    $input.attr('contenteditable', true)

    $input.on('focus', () => {
      if (!$contentInput.hasClass('active')) { $contentInput.addClass('active') }
    })
    $input.on('blur', () => {
      if ($contentInput.hasClass('active')) { $contentInput.removeClass('active') }
    })

    function isMobileMode () {
      const { device } = window.uaInfo.getResult()
      const type = _.get(device, 'type', '').toLowerCase()
      return type === 'mobile' || type === 'tablet'
    }
    $input.on('keydown', (event) => {
      this.toggleIcon()
      if (event.keyCode === KeyCode.ENTER) {
        event.preventDefault()
        this.$icon.click()
        if (isMobileMode()) {
          document.activeElement.blur()
        }
        setTimeout(() => {
          this.clearInput()
        }, 100)
      }
    })
    $input.on('keyup', () => {
      this.toggleIcon()
    })
    $input.on('paste', (event) => {
      event.stopPropagation()
      event.preventDefault()

      const clipboardData = event.clipboardData || window.clipboardData
      $input.appendContent(clipboardData.getData('Text'))
    })
    $contentInput.appendElement($input)

    let $icon = new Element()
    $icon.setClass([ 'icon' ])
    $contentInput.appendElement($icon)
    this.appendElement($contentInput)

    this.$content = $content
    this.$input = $input
    this.$icon = $icon
    this.reset()
  }

  getMessage () {
    return this.$input.val().trim()
  }

  createMessageElement (message) {
    let $item = new Element()
    $item.setClass('message-item')
    $item.attr('id', message.messageId)

    let $text = new Element()
    $text.setClass('message-text')

    let $nickname = new Element('label')
    let nicknameColor = 99
    $nickname.setClass('nickname', 'nickname-color-' + nicknameColor)
    $nickname.val(message.sender.nickname + MESSAGE_PREFIX)

    $text.appendElement($nickname)
    $text.appendContent(message.message, {
      xssProtectionEnabled: true,
      showEndOfLine: true
    })
    $item.appendElement($text)
    return $item
  }

  getTime (message) {
    const months = [
      '1월', '2월', '3월', '4월', '5월',
      '6월', '7월', '8월', '9월', '10월',
      '11월', '12월'
    ]

    var _getDay = (val) => {
      return parseInt(val) + '일'
    }

    var _checkTime = (val) => {
      return (+val < 10) ? '0' + val : val
    }

    if (message) {
      var _nowDate = new Date()
      var _date = new Date(message.createdAt)
      if (_nowDate.getDate() - _date.getDate() === 1) {
        return LAST_MESSAGE_YESTERDAY
      } else if (_nowDate.getFullYear() === _date.getFullYear() &&
        _nowDate.getMonth() === _date.getMonth() &&
        _nowDate.getDate() === _date.getDate()) {
        return _checkTime(_date.getHours()) + ':' + _checkTime(_date.getMinutes())
      } else {
        return months[_date.getMonth()] + ' ' + _getDay(_date.getDate())
      }
    }
    return ''
  }

  render (messageList, isScrollBottom, isLoadingMore, cbfn) {
    var moveScroll = 0
    for (let i in messageList) {
      let message = messageList[i]
      if (message.isUserMessage()) {
        let $item = this.createMessageElement(message)
        if (isLoadingMore) {
          let firstChild = this.$content.first()
          this.$content.insertBefore($item, firstChild)
        } else {
          this.$content.appendElement($item)
        }
        moveScroll += $item.getFullHeight()
        if (typeof cbfn === 'function') {
          cbfn()
        }
      } else {
        // put code here for other message type
      }
    }

    if (isLoadingMore) {
      // const orientation = getOrientation()
      // if (orientation === PORTRAIT) {
        window.scrollTo(0, moveScroll)
      // } else if (orientation === LANDSCAPE) {
        this.$chatBoard.scrollY(moveScroll)
      // }
    }

    if (isScrollBottom) {
      window.scrollTo(0, moveScroll)
      // } else if (orientation === LANDSCAPE) {
      this.$chatBoard.scrollY(moveScroll)
    }
  }

  reset () {
    this.senderColor = {}
  }

  toggleIcon () {
    if (this.$input.val() && this.$input.val().length > 0) {
      if (!this.$icon.hasClass('active')) {
        this.$icon.addClass('active')
      }
    } else {
      this.$icon.removeClass('active')
    }
  }

  clearInput () {
    let items = this.$input.findByTag('div')
    for (let i = 0; i < items.length; i++) {
      items[i].remove()
    }
    this.$input.val('')
    this.toggleIcon()
  }

  createBottomBar () {
    let _this = this
    let $btn = new Element('button')
    $btn.setClass('view-more-area btn btn-primary')
    $btn.val(MORE_MESSAGE_BELOW)
    $btn.on('click', () => {
      _this.$chat.goBottom()
    })
    if (!this.$bottom) {
      this.appendElement($btn.$)
      this.$bottom = $btn
    }
  }

  removeBottomBar () {
    if (this.$bottom) {
      this.removeElement(this.$bottom)
      this.$bottom = null
    }
  }
}

export { MessageBoard as default }
